export function modalHide(state) {
    state.modal = undefined;
    state.modalContext = undefined;

    document.documentElement.classList.remove('is-clipped');

    return state;
}
